import { Form } from 'factorial-form'

class CompanyHoliday extends Form {
  constructor(values: {}) {
    super(values, {
      date: 'date',
      day_type: 'string',
      description: 'string',
      half_day: 'string',
      location_id: 'string',
      summary: 'string',
    })
  }
}

export default CompanyHoliday
